<template>
    <div class="app">
        <div class="recommend-box">
            <div class="recommend-tips">为您推荐</div>
            <div class="recommend-item-box">
                <div class="recommend-left-box">
                    <div
                        class="recom-left-top"
                        @click="goDetail"
                    >
                        <div class="recom-left-title">每日生鲜大礼包</div>
                        <div class="recom-left-text">方便、快捷、全面</div>
                        <div class="recom-left-btn">立即购买</div>
                        <img
                            src="../../assets/image/img/首页/everysx.png"
                            alt=""
                        >
                    </div>
                    <div
                        class="recom-left-btm"
                        @click="goDetail"
                    >
                        <div class="recom-right-title">特质美味腐乳</div>
                        <div class="recom-right-text">方便、快捷、全面</div>
                        <div class="recom-right-btn">立即购买</div>
                        <img
                            src="../../assets/image/img/首页/frimg.png"
                            alt=""
                        >
                    </div>
                </div>
                <div class="recommend-center-box">
                    <div
                        class="recom-center-item"
                        @click="goDetail"
                    >
                        <div class="recomRight-title">进口生姜</div>
                        <div class="recomRight-text">低至9.9元</div>
                        <div class="more_icon">
                            <img
                                src="../../assets/image/img/首页/more_icon.png"
                                alt=""
                            >
                        </div>
                        <div class="centerimg-one">
                            <img
                                src="../../assets/image/img/首页/sj_img.png"
                                alt=""
                            >
                        </div>
                    </div>
                    <div
                        class="recom-center-item"
                        @click="goDetail"
                    >
                        <div class="recomRight-title">新鲜五花肉</div>
                        <div class="recomRight-text">低至29.9元</div>
                        <div class="more_icon">
                            <img
                                src="../../assets/image/img/首页/more_icon.png"
                                alt=""
                            >
                        </div>
                        <div class="centerimg-two">
                            <img
                                src="../../assets/image/img/首页/meatimg.png"
                                alt=""
                            >
                        </div>
                    </div>
                    <div
                        class="recom-center-item"
                        @click="goDetail"
                    >
                        <div class="recomRight-title">超大进口樱桃</div>
                        <div class="recomRight-text">低至29.9元</div>
                        <div class="more_icon">
                            <img
                                src="../../assets/image/img/首页/more_icon.png"
                                alt=""
                            >
                        </div>
                        <div class="centerimg-three">
                            <img
                                src="../../assets/image/img/首页/yt_img.png"
                                alt=""
                            >
                        </div>
                    </div>
                    <div
                        class="recom-center-item"
                        @click="goDetail"
                    >
                        <div class="recomRight-title">鲜活淡水虾</div>
                        <div class="recomRight-text">低至29.9元</div>
                        <div class="more_icon">
                            <img
                                src="../../assets/image/img/首页/more_icon.png"
                                alt=""
                            >
                        </div>
                        <div class="centerimg-four">
                            <img
                                src="../../assets/image/img/首页/xia_img.png"
                                alt=""
                            >
                        </div>
                    </div>
                </div>
                <div
                    class="recommend-right-box"
                    @click="goDetail"
                >
                    <div class="recomRight-title">每日水果套餐</div>
                    <div class="recomRight-text">低至29.9元</div>
                    <div class="more_icon">
                        <img
                            src="../../assets/image/img/首页/more_icon.png"
                            alt=""
                        >
                    </div>
                    <img
                        src="../../assets/image/img/首页/mrtc.png"
                        alt=""
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default
    {
        data()
        {
            return {}
        },
        methods:
        {
            goDetail()
            {
                this.$router.push(
                {
                    path: "/productlist"
                } )
            }
        }
    }
</script>

<style scoped="scoped">
    .centerimg-four {
        position: absolute;
        bottom: 1.125rem;
        right: 2.125rem;
    }

    .centerimg-four,
    .centerimg-four>img {
        width: 11.1875rem;
        height: 7.5rem;
    }

    .centerimg-three {
        position: absolute;
        bottom: 2.3125rem;
        right: 1.4375rem;
    }

    .centerimg-three,
    .centerimg-three>img {
        width: 7.75rem;
        height: 8.5625rem;
    }

    .centerimg-two {
        position: absolute;
        bottom: 1.875rem;
        right: 1.125rem;
    }

    .centerimg-two,
    .centerimg-two>img {
        width: 9.1875rem;
        height: 7.75rem;
    }

    .centerimg-one {
        position: absolute;
        bottom: 24px;
        right: 26px;
    }

    .centerimg-one,
    .centerimg-one>img {
        width: 8.3125rem;
        height: 8.3125rem;
    }

    .recom-center-item:nth-of-type(1),
    .recom-center-item:nth-of-type(4) {
        background-color: #EEEEEE !important;
    }

    .recom-center-item {
        width: 15.625rem;
        height: 14.625rem;
        background-color: #FAFAFA;
        margin-bottom: 0.625rem;
        padding: 1.6875rem 1.5rem 1.625rem 1.875rem;
        position: relative;
        cursor: pointer;
    }

    .recommend-right-box>img {
        width: 13.75rem;
        height: 21.375rem;
        position: absolute;
        bottom: 0;
        right: 0;
    }

    .more_icon {
        margin-top: 2.9375rem;
        box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.13);
        border-radius: 50%;
    }

    .more_icon,
    .more_icon>img {
        width: 1.5625rem;
        height: 1.5625rem;
    }

    .recomRight-text {
        color: #535353;
        font-size: 14px;
        margin-top: 0.5rem;
    }

    .recomRight-title {
        color: #2F2E2E;
        font-weight: 400;
        font-size: 16px;
    }

    .recom-left-btm>img {
        width: 14rem;
        height: 9.75rem;
        position: absolute;
        left: 0.625rem;
        bottom: 0.625rem;
    }

    .recom-right-btn {
        width: 6.4375rem;
        height: 2rem;
        text-align: center;
        line-height: 2rem;
        border: 1px solid #050505;
        color: #000000;
        font-size: 16px;
        margin-top: 1rem;
        margin-left: 17.5rem;
        cursor: pointer;
    }

    .recom-right-text {
        color: #37A115;
        margin-top: 0.625rem;
        font-size: 21px;
        font-weight: 400;
        text-align: right;
    }

    .recom-right-title {
        color: #020202;
        font-size: 24px;
        font-weight: 400;
        text-align: right;
    }

    .recom-left-top>img {
        width: 15rem;
        height: 11.75rem;
        position: absolute;
        bottom: -1.25rem;
        right: -1.25rem;
    }

    .recom-left-btn {
        width: 6.4375rem;
        height: 2rem;
        text-align: center;
        line-height: 2rem;
        border: 1px solid #FFFFFF;
        color: #FFFFFF;
        margin-top: 0.625rem;
        margin-left: 0.25rem;
        cursor: pointer;
    }

    .recom-left-text {
        color: #37A115;
        font-size: 21px;
        font-weight: 400;
        margin-top: 0.625rem;
    }

    .recom-left-title {
        color: #FFFFFF;
        font-size: 24px;
        font-weight: 400;
    }

    .recom-left-btm {
        width: 100%;
        height: 14.5625rem;
        border: 1px solid #37A115;
        margin-top: 0.5625rem;
        padding: 1.875rem 1.125rem 0 0;
        position: relative;
    }

    .recom-left-top {
        width: 100%;
        height: 14.5625rem;
        background: linear-gradient(-90deg, #1B1B1B, #3A3A3A);
        padding: 1.875rem 0 0 1rem;
        position: relative;
    }

    .recommend-right-box {
        width: 16.0625rem;
        height: 100%;
        background-color: #EEEEEE;
        padding: 1.6875rem 0 0 1.875rem;
        position: relative;
        cursor: pointer;
    }

    .recommend-center-box {
        width: 31.875rem;
        height: 100%;
        /* background-color: #069338; */
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .recommend-left-box {
        width: 25.75rem;
        height: 100%;
        /* background-color: #069338; */
    }

    .recommend-item-box {
        width: 100%;
        height: 29.75rem;
        display: flex;
        justify-content: space-between;
        margin-top: 1.875rem;
    }

    .recommend-tips {
        color: #1D1D1D;
        font-size: 24px;
        font-weight: 400;
    }

    .recommend-box {
        width: 75rem;
        height: auto;
        margin: 0 auto 3.4375rem auto;
        padding-top: 2.75rem;
    }
</style>